import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import genlogo from "../images/GEN_SKILL_COLLEGE_LOGO.png";

const values = [
  { icon: "bi-lightbulb", title: "Innovation", desc: "We integrate cutting-edge technology into every learning experience." },
  { icon: "bi-people", title: "Collaboration", desc: "Strong industry partnerships ensure real-world relevance in all programs." },
  { icon: "bi-shield-check", title: "Integrity", desc: "Transparent, ethical practices in education and student development." },
  { icon: "bi-rocket-takeoff", title: "Empowerment", desc: "We equip students to become self-reliant professionals and entrepreneurs." },
];

const team = [
  { name: "Dr. Academic Director", role: "Academic Head", icon: "bi-person-circle" },
  { name: "Industry Expert", role: "Program Director", icon: "bi-person-circle" },
  { name: "Career Specialist", role: "Placement Head", icon: "bi-person-circle" },
];

function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="page-header">
        <div className="container text-center">
          <h1 className="fw-bold text-white" data-aos="fade-down">About GEN Skill College</h1>
          <p className="text-white-50 mt-2" data-aos="fade-up">
            Building the bridge between education and employment
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-5 text-center" data-aos="zoom-in">
              <img src={genlogo} alt="GEN Skill College" className="img-fluid" style={{ maxWidth: "280px" }} />
            </div>
            <div className="col-lg-7" data-aos="fade-left">
              <h2 className="section-title">Our Mission</h2>
              <p className="text-muted">
                GEN Skill College is a premier institution under Transorze, dedicated to transforming
                traditional education through industry-aligned professional programs. We believe every
                student deserves access to quality skill development that leads directly to meaningful employment.
              </p>
              <p className="text-muted">
                Our curriculum is designed in collaboration with industry leaders, ensuring graduates
                possess the exact skills employers demand. From AI and automation to finance and creative arts,
                our programs cover the careers of tomorrow.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="section-title text-center mb-5" data-aos="fade-up">Our Core Values</h2>
          <div className="row g-4">
            {values.map((v, i) => (
              <div className="col-md-6 col-lg-3" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
                <div className="value-card text-center p-4 h-100">
                  <i className={`bi ${v.icon} value-icon`}></i>
                  <h5 className="fw-semibold mt-3">{v.title}</h5>
                  <p className="text-muted small">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5" data-aos="fade-up">Leadership Team</h2>
          <div className="row g-4 justify-content-center">
            {team.map((member, i) => (
              <div className="col-md-4" key={i} data-aos="zoom-in" data-aos-delay={i * 100}>
                <div className="team-card text-center p-4">
                  <i className={`bi ${member.icon} team-icon`}></i>
                  <h6 className="fw-semibold mt-3">{member.name}</h6>
                  <p className="text-muted small mb-0">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUs;
